import { FC, PropsWithChildren } from 'react';

export function assertUnreachable(x: any): never {
  throw new Error(`Reached code that should be unreachable: ${x}`);
}

export function assertUnreachableNever(x: never): never {
  throw new Error(`Reached code that should be unreachable: ${x}`);
}

export type FCC<P = {}> = FC<PropsWithChildren<P>>;
